<template>
    <div class="widget">
        <widget-title>Minha conta</widget-title>

        <ul class="links">
            <li><a href="my-account">Minha Conta</a></li>
            <li>
                <a href="my-account/purchases">
                    Histórico de {{ isBudgetLayout ? 'orçamentos' : 'pedidos' }}
                </a>
            </li>
            <template v-for="page in pages">
                <li v-if="page.show_footer == true" :key="page.id">
                    <a
                        :href="`${(page.slug ? $baseUrl+'page/'+page.slug : (page.link ? page.link : ''))}`"
                        :target="page.settings && JSON.parse(page.settings).open_link_in_new_tab == true ? '_blank' : '_self'"
                    >
                        {{page.title}}
                    </a>
                </li>
            </template>
            <li v-if="!clientLogged && !is_route_login"><a href="login">Login</a></li>
        </ul>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { CWidgetTitle } from '../Styles/Footer/styled'

export default {
    name: 'WidgetMyAccountLinks',
    components: {
        'widget-title': CWidgetTitle
    },
    props: {
        logged: {
            required: true
        },
        is_route_login: {
            default: false
        },
        pages: {
            default: []
        }
    },
    methods: {
        ...mapActions("clients", [
            "ActionSetEmailRegister"
        ]),
        openModalLogin() {   
            this.ActionSetEmailRegister(null)
            this.$root.showModalApp('login_modal')
        }
    },
    computed: {
        ...mapState("clients", [
            "clientLogged"
        ]),
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
    }
}
</script>
